import React, { useEffect, useState } from "react";
import ToolTip from "../../../Components/ToolTip";
import {
    Col,
    Row,
    Label,
    Button,
    Form,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
} from "reactstrap";
import { TooltipMsg } from "../../../Components/ToolTipMessage";
import AsyncSelect from "react-select/async";
import { Field, FieldProps, useFormikContext } from "formik";
import { customStyle, errorStyle } from "../../../shared/CommonCSS";
import { PortConstant } from "../../../shared/constants";
import FormValuesDebug from "../../../utils/debugTools/FormValuesDebug";
import {
    checkValidObject,
    dateTimeFormat,
    saveEditForm,
    searchCountries,
    searchPorts,
} from "GenericForms/Helper";
import env from "environment_system/env_system";
import ErrorTooltip from "Components/ErrorTooltip";
import Select from "react-select";
import { RootState } from "index";
import { useSelector } from "react-redux";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";
interface ETADComponentStructureType {
    toggleTab?: (activeTab: number) => void;
    setErrorMessage?: any;
    setRefreshKey?: any;
    refreshKey?: number;
    setVesselTransitVisibilty?: any;
    vesselTransitVisibilty?: boolean;
    fieldAvailability?: any;
    addOtherArrPort?: boolean;
    addOtherDepPort?: boolean;
    otherArrPort?: boolean;
    OtherPortsObject?: any;
    setAddOtherDepPort?: any;
    setOtherDepPort?: any;
    setAddOtherArrPort?: any;
    setOtherArrPort?: any;
    otherDepPort?: boolean;
    activeTab?: number;
    editValues?: any,
    setEditValues?: any,
    editInitialValues?: any;
    editSubmit?: any;
    editIsSubmitting?: any
}

const ETADComponentStructure = ({
    toggleTab,
    setErrorMessage,
    setRefreshKey,
    refreshKey,
    setVesselTransitVisibilty,
    vesselTransitVisibilty,
    fieldAvailability,
    addOtherArrPort,
    addOtherDepPort,
    otherArrPort,
    OtherPortsObject,
    setAddOtherDepPort,
    setOtherDepPort,
    setAddOtherArrPort,
    setOtherArrPort,
    otherDepPort,
    activeTab,
    editValues,
    setEditValues,
    editSubmit,
    editIsSubmitting,
}: ETADComponentStructureType) => {
    const { editReportBool, setPreviousDeckTabIndex, discardwarning } = useEditReport();
    /** State variables start */
    const { CurrentReport, PreviousReport } = useSelector((state: RootState) => state.Reporting);
    const previousVesselReport = PreviousReport?.data?.vessel_reporting_information ?? null;
    const ETADCurrentReport = CurrentReport?.data?.deck_officer?.expected_time_of_arrival ?? null;
    const [refreshDate, setRefreshDate] = useState<number>(0);
    const { values, errors, touched, handleChange, handleBlur, isSubmitting, handleSubmit, setErrors, setFieldTouched, validateForm }:
        {
            values: any, errors: any, touched: any, handleChange: any, handleBlur: any, setFieldValue: any,
            isSubmitting: any, handleSubmit: any, setErrors: any, setFieldTouched: any, validateForm: any
        } = useFormikContext<any>();
    const [validationsRefresh, setValidationsRefresh] = useState<number>(0);
    /** State variables end */

    /** useEffect start */
    useEffect(() => {
        if (editValues && editValues?.deck_officer?.expected_time_of_arrival?.id > 0) {
            setEditValues({
                ...editValues,
                deck_officer: {
                    ...editValues?.deck_officer,
                    expected_time_of_arrival: values
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values])
    /** useEffect end */

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off" key={refreshKey}>
            <CardBody className="px-0 py-2 pb-0">
                <Row>
                    <Col lg={6} className="">
                        <Card>
                            <CardHeader className="p-2">
                                <h5 className="m-0">Arrival</h5>
                            </CardHeader>
                            <CardBody className="p-2">
                                <div>
                                    <Label
                                        className={`${fieldAvailability.arrival_port ? "asteric" : null
                                            } mb-0`}
                                        for="arrival_port"
                                    >
                                        Arrival port name
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="arrival_port_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="arrival_port_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) => item.target === "arrival_port_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <Field name="arrival_port">
                                        {({ field, form }: FieldProps) => (
                                            <span className={`p-0 ${!fieldAvailability.arrival_port ? "cursor-not-allowed" : "pointer"}`}>
                                                <AsyncSelect
                                                    name={field.name}
                                                    inputId="arrival_port"
                                                    className={`max-width-25 ${!fieldAvailability.arrival_port && "cursor-not-allowed"}`}
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={(e: any) => searchPorts(e)}
                                                    getOptionLabel={(e: any) => e.port_country_name}
                                                    getOptionValue={(e: any) => e.id}
                                                    onBlur={handleBlur}
                                                    autoFocus={!fieldAvailability.arrival_port ? false : true}
                                                    onChange={(selectedOption: any) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            selectedOption.id
                                                        );
                                                        form.setFieldValue(
                                                            'arrival_port_country_name',
                                                            selectedOption.port_country_name
                                                        );
                                                        if (
                                                            selectedOption?.precedence_id ===
                                                            PortConstant.OTHER &&
                                                            addOtherArrPort === false
                                                        ) {
                                                            form.setFieldValue("arrival_precedence_id", PortConstant.OTHER);
                                                            setOtherArrPort(true);
                                                        } else if (
                                                            selectedOption?.precedence_id !==
                                                            PortConstant.OTHER
                                                        ) {
                                                            form.setFieldValue("arrival_precedence_id", null);
                                                            setOtherArrPort(false);
                                                            setAddOtherArrPort(false);
                                                            form.setFieldValue(
                                                                "other_arrival_port_name",
                                                                null
                                                            );
                                                            form.setFieldValue(
                                                                "other_arrival_port",
                                                                null
                                                            );
                                                            form.setFieldValue(
                                                                "other_arrival_port_country",
                                                                null
                                                            );
                                                            form.setFieldValue(
                                                                "other_arrival_port_country_name",
                                                                null
                                                            );
                                                        }
                                                    }}
                                                    defaultValue={{
                                                        id: values?.arrival_port,
                                                        port_country_name: values?.arrival_port_country_name,
                                                    }
                                                    }
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        ...(
                                                            errors.arrival_port == null
                                                                ? customStyle
                                                                : errorStyle
                                                        ),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 9999,// Ensures the dropdown menu is above other elements
                                                        }),
                                                        menuPortal: (provided) => ({
                                                            ...provided,
                                                            zIndex: 9999, // Ensures the menu portal is above other elements
                                                        }),
                                                    }}
                                                    isDisabled={!fieldAvailability.arrival_port}
                                                    noOptionsMessage={(e: any) => {
                                                        if (e?.inputValue?.toString()?.length > 2) {
                                                            return "Please select the Other option and enter the port name in the textbox provided";
                                                        }
                                                        return "Please enter the first 3 characters of port name";
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </Field>
                                    {errors && touched &&
                                        touched?.arrival_port &&
                                        errors?.arrival_port &&
                                        env?.form_validation === true && !discardwarning && (
                                            <ErrorTooltip
                                                target="arrival_port"
                                                message={errors?.arrival_port}
                                                open={errors?.arrival_port ? true : false}
                                            />
                                        )}
                                </div>
                                {otherArrPort === true &&
                                    OtherPortsObject && (
                                        <>
                                            <Label
                                                className="mb-0 mt-2 asteric"
                                                for="other_arrival_port_name_dropdown"
                                            >
                                                Other arrival port
                                            </Label>
                                            <Field name="other_arrival_port">
                                                {({ field, form }: FieldProps) => (
                                                    <Select
                                                        name={field.name}
                                                        inputId="other_arrival_port_name_dropdown"
                                                        className="max-width-25"
                                                        options={OtherPortsObject}
                                                        getOptionLabel={(e: any) => e.port_name}
                                                        getOptionValue={(e: any) => e.id}
                                                        onBlur={handleBlur}
                                                        onChange={(selectedOption: any) => {
                                                            form.setFieldValue(
                                                                field.name,
                                                                selectedOption.id
                                                            );
                                                            form.setFieldValue(
                                                                "other_arrival_port_name",
                                                                selectedOption?.port_name
                                                            );
                                                            form.setFieldValue(
                                                                "other_arrival_port_country",
                                                                selectedOption?.country
                                                            );
                                                        }}
                                                        defaultValue={{
                                                            id: values?.other_arrival_port,
                                                            port_name: values?.other_arrival_port_name,
                                                        }
                                                        }
                                                        menuPortalTarget={document.body}
                                                        styles={customStyle}
                                                        noOptionsMessage={(e: any) => {
                                                            if (
                                                                e?.inputValue?.toString()?.length > 2
                                                            ) {
                                                                return "Please select the Other option and enter the port name in the textbox provided";
                                                            }
                                                            return "Please enter the first 3 characters of port name";
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            {errors && touched &&
                                                errors?.other_arrival_port &&
                                                touched?.other_arrival_port &&
                                                env?.form_validation === true &&
                                                !discardwarning &&
                                                <ErrorTooltip
                                                    target="other_arrival_port_name_dropdown"
                                                    message={errors?.other_arrival_port}
                                                    open={
                                                        errors?.other_arrival_port
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            }
                                            <p
                                                className="link_color_blue pointer"
                                                onClick={() => {
                                                    setAddOtherArrPort(true);
                                                    setOtherArrPort(false);
                                                    values.other_arrival_port = null;
                                                    values.other_arrival_port_name = null;
                                                    values.other_arrival_port_country = null;
                                                }}
                                            >
                                                Click here to add new port
                                            </p>
                                        </>
                                    )}
                                {(addOtherArrPort === true || !OtherPortsObject) && (
                                    <div className="mb-3 mt-3 ele_row1">
                                        <Col sm={5}>
                                            <Label
                                                className="mb-0 asteric"
                                                for="other_arrival_port_name"
                                            >
                                                Other arrival port
                                            </Label>
                                            <Field
                                                type="text"
                                                name="other_arrival_port_name"
                                                id="other_arrival_port_name"
                                                className="form-control max-width-20"
                                            />
                                            {errors && touched &&
                                                errors?.other_arrival_port_name &&
                                                touched?.other_arrival_port_name &&
                                                env?.form_validation === true && !discardwarning && (
                                                    <ErrorTooltip
                                                        target="other_arrival_port_name"
                                                        message={errors?.other_arrival_port_name}
                                                        open={
                                                            errors?.other_arrival_port_name
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                )}
                                        </Col>
                                        <Col sm={5} className="ms-3">
                                            <Label className="mb-0 asteric">
                                                Other arrival port country
                                            </Label>
                                            <Field name="other_arrival_port_country">
                                                {({ field, form }: FieldProps) => (
                                                    <AsyncSelect
                                                        name={field.name}
                                                        id={field.name}
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={(e: any) => searchCountries(e)}
                                                        getOptionLabel={(e: any) => e.country_name}
                                                        getOptionValue={(e: any) => e.id}
                                                        onBlur={(e) => handleBlur(e)}
                                                        onChange={(e: any) =>
                                                            form.setFieldValue(field.name, e?.id)
                                                        }
                                                        styles={customStyle}
                                                        noOptionsMessage={() => {
                                                            return "Please enter the first 3 characters of country name";
                                                        }}
                                                        defaultValue={{
                                                            id: values?.other_arrival_port_country,
                                                            port_name: values?.other_arrival_port_country_name,
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            {errors && touched &&
                                                errors?.other_arrival_port_country &&
                                                touched?.other_arrival_port_country &&
                                                env?.form_validation === true &&
                                                !discardwarning &&
                                                <ErrorTooltip
                                                    target="other_arrival_port_country"
                                                    message={errors?.other_arrival_port_country}
                                                    open={
                                                        errors?.other_arrival_port_country
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            }
                                        </Col>
                                    </div>
                                )}
                                <div className="mb-3 mt-3">
                                    <Label
                                        className={`${fieldAvailability.masters_eta_at_pilot_station
                                            ? "asteric"
                                            : null
                                            } mb-0`}
                                        for="masters_eta_at_pilot_station"
                                    >
                                        Master's ETA at pilot station(Local)
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="masters_eta_at_pilot_station_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="masters_eta_at_pilot_station_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target ===
                                                "masters_eta_at_pilot_station_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <Field name="masters_eta_at_pilot_station">
                                        {({ field }: FieldProps) => (
                                            <input
                                                type="datetime-local"
                                                name={field.name}
                                                id="masters_eta_at_pilot_station"
                                                min={dateTimeFormat(
                                                    previousVesselReport?.local_time
                                                )}
                                                max={"9999-12-31T00:00"}
                                                className={`datetimepicker text-uppercase form-control mt-0 w-12 ${!fieldAvailability.masters_eta_at_pilot_station && "cursor-not-allowed"}`}
                                                defaultValue={dateTimeFormat(
                                                    values.masters_eta_at_pilot_station,
                                                    false,
                                                    true
                                                )}
                                                disabled={
                                                    !fieldAvailability.masters_eta_at_pilot_station
                                                }
                                                onBlur={handleBlur}
                                                onChange={(e: any) => handleChange(e)}
                                            />
                                        )}
                                    </Field>
                                    {errors && touched &&
                                        touched?.masters_eta_at_pilot_station &&
                                        errors?.masters_eta_at_pilot_station &&
                                        document.getElementById("masters_eta_at_pilot_station") !== null &&
                                        env?.form_validation === true && !discardwarning && (
                                            <ErrorTooltip
                                                key={validationsRefresh}
                                                target="masters_eta_at_pilot_station"
                                                message={errors?.masters_eta_at_pilot_station}
                                                open={
                                                    errors?.masters_eta_at_pilot_station
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                </div>
                                <div className="mb-1">
                                    <Field
                                        name="is_arrival_port_in_eca"
                                    >
                                        {({ field, form }: FieldProps) => (
                                            <span className={`p-0 ${!fieldAvailability.is_arrival_port_in_eca ? "cursor-not-allowed" : "pointer"}`}>
                                                <input
                                                    className="form-check-input mr-0-5"
                                                    type="checkbox"
                                                    id="is_arrival_port_in_eca"
                                                    key={refreshDate}
                                                    name={field.name}
                                                    defaultChecked={values.is_arrival_port_in_eca}
                                                    disabled={
                                                        !fieldAvailability.is_arrival_port_in_eca
                                                    }
                                                    onChange={(e: any) => {
                                                        handleChange(e)
                                                        const checked = e.target.checked;
                                                        form.setFieldValue("is_arrival_port_in_eca", checked);
                                                        if (!checked) {
                                                            form.setFieldValue("expected_time_of_arrival_at_eca", null);
                                                            setRefreshDate(refreshDate + 1);
                                                        }
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </Field>
                                    <Label for="is_arrival_port_in_eca">
                                        Is arrival port in ECA and vessel is yet to enter
                                        the region?
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="is_arrival_port_in_eca_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="is_arrival_port_in_eca_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target === "is_arrival_port_in_eca_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Label
                                        className={`mb-0 ${values?.is_arrival_port_in_eca === true
                                            ? "asteric"
                                            : ""
                                            }`}
                                        for="expected_time_of_arrival_at_eca"
                                    >
                                        Expected time of arrival at ECA(Local)
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="expected_time_of_arrival_at_eca_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="expected_time_of_arrival_at_eca_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target ===
                                                "expected_time_of_arrival_at_eca_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <Field name="expected_time_of_arrival_at_eca">
                                        {({ field }: FieldProps) => (
                                            <input
                                                type="datetime-local"
                                                name={field.name}
                                                id="expected_time_of_arrival_at_eca"
                                                min={dateTimeFormat(
                                                    previousVesselReport?.local_time
                                                )}
                                                key={refreshDate}
                                                max={"9999-12-31T00:00"}
                                                className={`datetimepicker text-uppercase form-control mt-0 w-12 ${!values.is_arrival_port_in_eca && "cursor-not-allowed"}`}
                                                value={dateTimeFormat(
                                                    values.expected_time_of_arrival_at_eca,
                                                    false,
                                                    true
                                                )}
                                                disabled={!values.is_arrival_port_in_eca}
                                                onChange={(e: any) => handleChange(e)}
                                                onBlur={handleBlur}
                                            />
                                        )}
                                    </Field>
                                    {errors && touched &&
                                        errors?.expected_time_of_arrival_at_eca &&
                                        touched.expected_time_of_arrival_at_eca &&
                                        env?.form_validation === true &&
                                        values?.is_arrival_port_in_eca && !discardwarning && (
                                            <ErrorTooltip
                                                target="expected_time_of_arrival_at_eca"
                                                message={
                                                    errors?.expected_time_of_arrival_at_eca
                                                }
                                                open={
                                                    errors?.expected_time_of_arrival_at_eca
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg={6} className="">
                        <Card>
                            <CardHeader className="p-2">
                                <h5 className="m-0">Departure</h5>
                            </CardHeader>
                            <CardBody className="p-2">
                                <div>
                                    <Label
                                        className={`mb-0 ${fieldAvailability.departure_port ? "asteric" : ""
                                            }`}
                                        for="departure_port"
                                    >
                                        Departure port name
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="departure_port_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="departure_port_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target === "departure_port_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <Field name="departure_port">
                                        {({ field, form }: FieldProps) => (
                                            <span className={`p-0 ${!fieldAvailability.departure_port ? "cursor-not-allowed" : "pointer"}`}>
                                                <AsyncSelect
                                                    name={field.name}
                                                    inputId="departure_port"
                                                    className="max-width-25 mb-3"
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={(e: any) => searchPorts(e)}
                                                    getOptionLabel={(e: any) => e?.port_country_name}
                                                    getOptionValue={(e: any) => e?.id}
                                                    autoFocus={!fieldAvailability.departure_port ? false : true}
                                                    onBlur={() => {
                                                        form.setFieldTouched(field.name);
                                                    }}
                                                    onChange={(selectedOption: any) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            selectedOption.id
                                                        );
                                                        form.setFieldValue(
                                                            'departure_port_country_name',
                                                            selectedOption.port_country_name
                                                        );
                                                        if (
                                                            selectedOption?.precedence_id ===
                                                            PortConstant.OTHER &&
                                                            addOtherDepPort === false
                                                        ) {
                                                            form.setFieldValue("departure_precedence_id", PortConstant.OTHER);
                                                            setOtherDepPort(true);
                                                        } else if (
                                                            selectedOption?.precedence_id !==
                                                            PortConstant.OTHER
                                                        ) {
                                                            form.setFieldValue("departure_precedence_id", null);
                                                            setOtherDepPort(false);
                                                            setAddOtherDepPort(false);
                                                            form.setFieldValue(
                                                                "other_departure_port_name",
                                                                null
                                                            );
                                                            form.setFieldValue(
                                                                "other_departure_port",
                                                                null
                                                            );
                                                            form.setFieldValue(
                                                                "other_departure_port_country",
                                                                null
                                                            );
                                                            form.setFieldValue(
                                                                "other_departure_port_country_name",
                                                                null
                                                            );
                                                        }
                                                        setValidationsRefresh(validationsRefresh + 1);
                                                    }}
                                                    defaultValue={{
                                                        id: values?.departure_port,
                                                        port_country_name: values?.departure_port_country_name,
                                                    }}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        ...(
                                                            errors.arrival_port == null
                                                                ? customStyle
                                                                : errorStyle
                                                        ),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 9999,
                                                        }),
                                                        menuPortal: (provided) => ({
                                                            ...provided,
                                                            zIndex: 9999,
                                                        }),
                                                    }}
                                                    isDisabled={!fieldAvailability.departure_port}
                                                    noOptionsMessage={(e: any) => {
                                                        if (e?.inputValue?.toString()?.length > 2) {
                                                            return "Please select the Other option and enter the port name in the textbox provided";
                                                        }
                                                        return "Please enter the first 3 characters of port name";
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </Field>
                                    {errors && touched &&
                                        errors?.departure_port &&
                                        touched?.departure_port &&
                                        env?.form_validation === true && !discardwarning && (
                                            <ErrorTooltip
                                                target="departure_port"
                                                message={errors?.departure_port}
                                                open={errors?.departure_port ? true : false}
                                            />
                                        )}
                                </div>
                                {otherDepPort === true &&
                                    OtherPortsObject && (
                                        <React.Fragment>
                                            <Label
                                                className="mb-0 mt-2 asteric"
                                                for="other_departure_port_name_dropdown"
                                            >
                                                Other departure port
                                            </Label>
                                            <Field name="other_departure_port">
                                                {({ field, form }: FieldProps) => (
                                                    <Select
                                                        name={field.name}
                                                        inputId="other_departure_port_name_dropdown"
                                                        className="max-width-25"
                                                        options={OtherPortsObject}
                                                        getOptionLabel={(e: any) => e.port_name}
                                                        getOptionValue={(e: any) => e.id}
                                                        onBlur={handleBlur}
                                                        onChange={(selectedOption: any) => {
                                                            form.setFieldValue(
                                                                field.name,
                                                                selectedOption.id
                                                            );
                                                            form.setFieldValue(
                                                                "other_departure_port_name",
                                                                selectedOption?.port_name
                                                            );
                                                            form.setFieldValue(
                                                                "other_departure_port_country",
                                                                selectedOption?.country
                                                            );
                                                        }}
                                                        defaultValue={{
                                                            id: values?.other_departure_port,
                                                            port_name: values?.other_departure_port_name,
                                                        }}
                                                        styles={
                                                            errors.departure_port === null
                                                            ? customStyle
                                                            : errorStyle
                                                        }
                                                        menuPortalTarget={document.body}
                                                        noOptionsMessage={(e: any) => {
                                                            if (
                                                                e?.inputValue?.toString()?.length > 2
                                                            ) {
                                                                return "Please select the Other option and enter the port name in the textbox provided";
                                                            }
                                                            return "Please enter the first 3 characters of port name";
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            {errors && touched &&
                                                errors?.other_departure_port &&
                                                touched?.other_departure_port &&
                                                env?.form_validation === true &&
                                                !discardwarning &&
                                                <ErrorTooltip
                                                    target="other_departure_port_name_dropdown"
                                                    message={errors?.other_departure_port}
                                                    open={errors?.other_departure_port ? true : false}
                                                />
                                            }
                                            <p
                                                className="link_color_blue pointer"
                                                onClick={() => {
                                                    setAddOtherDepPort(true);
                                                    setOtherDepPort(false);
                                                    values.other_departure_port = null;
                                                    values.other_departure_port_name = null;
                                                    values.other_departure_port_country = null;
                                                }}
                                            >
                                                Click here to add new port
                                            </p>
                                        </React.Fragment>
                                    )}
                                {(addOtherDepPort === true || !OtherPortsObject) && (
                                    <div className="mb-3 mt-3 ele_row1">
                                        <Col sm={5}>
                                            <Label
                                                className="mb-0 asteric"
                                                for="other_departure_port_name"
                                            >
                                                Other departure port
                                            </Label>
                                            <Field
                                                type="text"
                                                name="other_departure_port_name"
                                                id="other_departure_port_name"
                                                className="form-control max-width-20"
                                            />
                                            {errors && touched &&
                                                errors?.other_departure_port_name &&
                                                touched?.other_departure_port_name &&
                                                env?.form_validation === true && !discardwarning && (
                                                    <ErrorTooltip
                                                        target="other_departure_port_name"
                                                        message={errors?.other_departure_port_name}
                                                        open={
                                                            errors?.other_departure_port_name
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                )}
                                        </Col>
                                        <Col sm={5} className="ms-3">
                                            <Label className="mb-0 asteric">
                                                Other departure port country
                                            </Label>
                                            <Field name="other_departure_port_country">
                                                {({ field, form }: FieldProps) => (
                                                    <AsyncSelect
                                                        name={field.name}
                                                        id={field.name}
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={(e: any) => searchCountries(e)}
                                                        getOptionLabel={(e: any) => e.country_name}
                                                        getOptionValue={(e: any) => e.id}
                                                        onChange={(e: any) =>
                                                            form.setFieldValue(field.name, e?.id)
                                                        }
                                                        styles={customStyle}
                                                        noOptionsMessage={() => {
                                                            return "Please enter the first 3 characters of country name";
                                                        }}
                                                        defaultValue={checkValidObject(ETADCurrentReport) && {
                                                            id: ETADCurrentReport?.other_departure_port_country,
                                                            port_name: ETADCurrentReport?.other_departure_port_country_name,
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            {errors && touched &&
                                                errors?.other_departure_port_country &&
                                                touched?.other_departure_port_country &&
                                                env?.form_validation === true && !discardwarning && (
                                                    <ErrorTooltip
                                                        target="other_departure_port_country"
                                                        message={
                                                            errors?.other_departure_port_country
                                                        }
                                                        open={
                                                            errors?.other_departure_port_country
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                )}
                                        </Col>
                                    </div>
                                )}
                                <div className="mb-3">
                                    <Label
                                        className={`mb-0 ${fieldAvailability.master_etd_from_present_port ? "asteric" : ""}`}
                                        for="master_etd_from_present_port"
                                    >
                                        Master's ETD from present port(Local)
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="master_etd_from_present_port_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="master_etd_from_present_port_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target ===
                                                "master_etd_from_present_port_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <Field name="master_etd_from_present_port">
                                        {({ field }: FieldProps) => (
                                            <input
                                                type="datetime-local"
                                                name={field.name}
                                                id="master_etd_from_present_port"
                                                min={dateTimeFormat(
                                                    previousVesselReport?.local_time
                                                )}
                                                max={"9999-12-31T00:00"}
                                                className={`datetimepicker text-uppercase form-control mt-0 w-12 ${!fieldAvailability.master_etd_from_present_port && "cursor-not-allowed"}`}
                                                disabled={
                                                    !fieldAvailability.master_etd_from_present_port
                                                }
                                                defaultValue={dateTimeFormat(
                                                    values.master_etd_from_present_port,
                                                    false,
                                                    true
                                                )}
                                                onBlur={(e: any) => handleBlur(e)}
                                                onChange={(e: any) => handleChange(e)}
                                            />
                                        )}
                                    </Field>
                                    {errors && touched &&
                                        errors?.master_etd_from_present_port &&
                                        touched?.master_etd_from_present_port &&
                                        document.getElementById("master_etd_from_present_port") !== null &&
                                        env?.form_validation === true && !discardwarning && (
                                            <ErrorTooltip
                                                key={validationsRefresh}
                                                target="master_etd_from_present_port"
                                                message={
                                                    errors?.master_etd_from_present_port
                                                }
                                                open={
                                                    errors?.master_etd_from_present_port
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                </div>
                                <div className="mb-1">
                                    <Field name="is_departure_port_in_eca">
                                        {({ field, form }: FieldProps) => (
                                            <span className={`p-0 ${!fieldAvailability.is_departure_port_in_eca ? "cursor-not-allowed" : "pointer"}`}>
                                                <input
                                                    className="form-check-input mr-0-5"
                                                    type="checkbox"
                                                    id="is_departure_port_in_eca"
                                                    name={field.name}
                                                    defaultChecked={values.is_departure_port_in_eca}
                                                    onChange={(e: any) => {
                                                        const checked = e.target.checked;
                                                        form.setFieldValue("is_departure_port_in_eca", checked);
                                                        // Clear the datetime if unchecked
                                                        if (!checked) {
                                                            form.setFieldValue("expected_time_of_depature_from_eca", null);
                                                            form.setFieldValue('expected_time_of_arrival_at_eca', null);
                                                            setRefreshDate((prev: number) => prev + 1);
                                                        }
                                                    }}
                                                    disabled={
                                                        !fieldAvailability.is_departure_port_in_eca
                                                    }
                                                />
                                            </span>
                                        )}
                                    </Field>
                                    <Label for="is_departure_port_in_eca">
                                        Is departure port in ECA and vessel is yet to exit
                                        the region?
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="is_departure_port_in_eca_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="is_departure_port_in_eca_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target === "is_departure_port_in_eca_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Label
                                        className={`mb-0 ${fieldAvailability.expected_time_of_depature_from_eca
                                            ? "aasteric"
                                            : ""
                                            }`}
                                        for="expected_time_of_depature_from_eca"
                                    >
                                        Expected time of departure from ECA(Local)
                                        <i
                                            className="bx bx-info-circle ml-2p"
                                            id="expected_time_of_depature_from_eca_msg"
                                        />
                                    </Label>
                                    <ToolTip
                                        target="expected_time_of_depature_from_eca_msg"
                                        message={`${TooltipMsg.ETADD.filter(
                                            (item: any) =>
                                                item.target ===
                                                "expected_time_of_depature_from_eca_msg"
                                        ).map((tool: any) => {
                                            return tool.message;
                                        })}`}
                                    />
                                    <Field name="expected_time_of_depature_from_eca">
                                        {({ field, form }: FieldProps) => (
                                            <input
                                                type="datetime-local"
                                                name={field.name}
                                                id="expected_time_of_depature_from_eca"
                                                min={dateTimeFormat(
                                                    previousVesselReport?.local_time
                                                )}
                                                key={refreshDate}
                                                max={"9999-12-31T00:00"}
                                                className={`datetimepicker text-uppercase form-control mt-0 w-12 ${!values?.is_departure_port_in_eca && "cursor-not-allowed"}`}
                                                disabled={!values?.is_departure_port_in_eca}
                                                value={dateTimeFormat(
                                                    values.expected_time_of_depature_from_eca,
                                                    false,
                                                    true
                                                )}
                                                onChange={(e: any) => handleChange(e)}
                                                onBlur={() => {
                                                    form.setFieldTouched(field.name);
                                                }}
                                            />
                                        )}
                                    </Field>
                                    {errors && touched &&
                                        errors?.expected_time_of_depature_from_eca &&
                                        touched.expected_time_of_depature_from_eca &&
                                        env?.form_validation === true &&
                                        values?.is_departure_port_in_eca && !discardwarning && (
                                            <ErrorTooltip
                                                target="expected_time_of_depature_from_eca"
                                                message={
                                                    errors?.expected_time_of_depature_from_eca
                                                }
                                                open={
                                                    errors?.expected_time_of_depature_from_eca
                                                        ? true
                                                        : false
                                                }
                                            />
                                        )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody className="px-2 ">
                                <div>
                                    <div className="form-check">
                                        <Field name="vessel_transit">
                                            {({ field, form }: FieldProps) => (
                                                <span className={`p-0 ${!fieldAvailability.vessel_transit ? "cursor-not-allowed" : "pointer"}`}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="vessel_transit"
                                                        name={field.name}
                                                        checked={field.value}
                                                        onChange={(e) => {
                                                            setRefreshDate((prev: number) => prev + 1);
                                                            const isChecked = e.target.checked;
                                                            form.setFieldValue("vessel_transit", isChecked);
                                                            if (!isChecked) {
                                                                // Clear values
                                                                form.setFieldValue("date_and_time_of_arrival_at_eca", null);
                                                                form.setFieldValue("date_and_time_of_departure_from_eca", null);
                                                                // Clear errors
                                                                const errors = { ...form.errors };
                                                                delete errors.date_and_time_of_arrival_at_eca;
                                                                delete errors.date_and_time_of_departure_from_eca;
                                                                form.setErrors(errors);
                                                                // Clear touched
                                                                const touched = { ...form.touched };
                                                                delete touched.date_and_time_of_arrival_at_eca;
                                                                delete touched.date_and_time_of_departure_from_eca;
                                                                form.setTouched(touched);
                                                                // Refresh UI state
                                                                setVesselTransitVisibilty(false);
                                                            } else {
                                                                setVesselTransitVisibilty(true);
                                                            }
                                                            // Optional: trigger validation if needed
                                                            setTimeout(() => {
                                                                form.validateForm();
                                                            }, 0);
                                                        }}
                                                        disabled={!fieldAvailability.vessel_transit}
                                                        defaultChecked={values.vessel_transit}
                                                    />
                                                </span>
                                            )}
                                        </Field>
                                        <Label for="vessel_transit">
                                            Will vessel transit ECA region?
                                            <i
                                                className="bx bx-info-circle ml-2p"
                                                id="vessel_transit_msg"
                                            />
                                        </Label>
                                        <ToolTip
                                            target="vessel_transit_msg"
                                            message={`${TooltipMsg.ETADD.filter(
                                                (item: any) =>
                                                    item.target === "vessel_transit_msg"
                                            ).map((tool: any) => {
                                                return tool.message;
                                            })}`}
                                        />
                                    </div>
                                    <React.Fragment>
                                        <div className="mb-3">
                                            <Label
                                                className="mb-0"
                                                for="date_and_time_of_arrival_at_eca"
                                            >
                                                Date & time of arrival at ECA incase vessel is
                                                yet to enter the region(Local)
                                                <i
                                                    className="bx bx-info-circle ml-2p"
                                                    id="date_and_time_of_arrival_at_eca_msg"
                                                />
                                            </Label>
                                            <ToolTip
                                                target="date_and_time_of_arrival_at_eca_msg"
                                                message={`${TooltipMsg.ETADD.filter(
                                                    (item: any) =>
                                                        item.target ===
                                                        "date_and_time_of_arrival_at_eca_msg"
                                                ).map((tool: any) => {
                                                    return tool.message;
                                                })}`}
                                            />
                                            <Field name="date_and_time_of_arrival_at_eca">
                                                {({ field }: FieldProps) => (
                                                    <input
                                                        type="datetime-local"
                                                        name={field.name}
                                                        id="date_and_time_of_arrival_at_eca"
                                                        min={dateTimeFormat(
                                                            previousVesselReport.local_time
                                                        )}
                                                        key={refreshDate}
                                                        max={"9999-12-31T00:00"}
                                                        value={dateTimeFormat(
                                                            values.date_and_time_of_arrival_at_eca,
                                                            false,
                                                            true
                                                        )}
                                                        className={`datetimepicker text-uppercase form-control mt-0 w-12 ${!values.vessel_transit && "cursor-not-allowed"}`}
                                                        disabled={!values.vessel_transit}
                                                        onChange={(e: any) => handleChange(e)}
                                                        onBlur={handleBlur}
                                                    />
                                                )}
                                            </Field>
                                            {errors && touched &&
                                                errors?.date_and_time_of_arrival_at_eca &&
                                                touched.date_and_time_of_arrival_at_eca &&
                                                env?.form_validation === true && vesselTransitVisibilty &&
                                                !discardwarning &&
                                                <ErrorTooltip
                                                    target="date_and_time_of_arrival_at_eca"
                                                    message={
                                                        errors?.date_and_time_of_arrival_at_eca
                                                    }
                                                    open={
                                                        errors?.date_and_time_of_arrival_at_eca
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            }
                                        </div>
                                        <div className="mb-2">
                                            <Label
                                                className="mb-0"
                                                for="date_and_time_of_departure_from_eca"
                                            >
                                                Date & time of departure from ECA(Local)
                                                <i
                                                    className="bx bx-info-circle ml-2p"
                                                    id="date_and_time_of_departure_from_eca_msg"
                                                />
                                            </Label>
                                            <ToolTip
                                                target="date_and_time_of_departure_from_eca_msg"
                                                message={`${TooltipMsg.ETADD.filter(
                                                    (item: any) =>
                                                        item.target ===
                                                        "date_and_time_of_departure_from_eca_msg"
                                                ).map((tool: any) => {
                                                    return tool.message;
                                                })}`}
                                            />
                                            <Field name="date_and_time_of_departure_from_eca">
                                                {({ field }: FieldProps) => (
                                                    <input
                                                        type="datetime-local"
                                                        name={field.name}
                                                        id="date_and_time_of_departure_from_eca"
                                                        min={dateTimeFormat(
                                                            previousVesselReport.local_time
                                                        )}
                                                        max={"9999-12-31T00:00"}
                                                        className={`datetimepicker text-uppercase form-control mt-0 w-12 ${!values.vessel_transit && "cursor-not-allowed"}`}
                                                        disabled={!values.vessel_transit}
                                                        value={dateTimeFormat(
                                                            values.date_and_time_of_departure_from_eca,
                                                            false,
                                                            true
                                                        )}
                                                        key={refreshDate}
                                                        onChange={(e: any) => handleChange(e)}
                                                        onBlur={(e: any) => { handleBlur(e); setFieldTouched("date_and_time_of_departure_from_eca", true); }}
                                                    />
                                                )}
                                            </Field>
                                            {errors &&
                                                errors?.date_and_time_of_departure_from_eca &&
                                                touched.date_and_time_of_departure_from_eca &&
                                                env?.form_validation === true && vesselTransitVisibilty &&
                                                !discardwarning &&
                                                <ErrorTooltip
                                                    target="date_and_time_of_departure_from_eca"
                                                    message={
                                                        errors?.date_and_time_of_departure_from_eca
                                                    }
                                                    open={
                                                        errors?.date_and_time_of_departure_from_eca
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            }
                                        </div>
                                    </React.Fragment>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </CardBody>
            <CardFooter className="p-2 py-3">
                <Row className="d-flex align-items-center flex-row-reverse">
                    <Col lg={10}>
                        <div className="d-flex flex-wrap gap-3 justify_right">
                            {/* {editReportBool &&
                                <Button
                                    type="reset"
                                    color="danger"
                                    className="btn_size_cstm"
                                    onClick={() => {
                                        setEditValues({
                                            ...editValues,
                                            deck_officer: {
                                                ...editValues?.deck_officer,
                                                draft_and_displacement: editInitialValues?.deck_officer?.draft_and_displacement,
                                                cargo_detail: editInitialValues?.deck_officer?.cargo_detail,
                                                container_detail: editInitialValues?.deck_officer?.container_detail,
                                                reefer_container_details: editInitialValues?.deck_officer?.reefer_container_details,
                                                bill_of_lading: editInitialValues?.deck_officer?.bill_of_lading,
                                                ballast_details: editInitialValues?.deck_officer?.ballast_details,
                                                vessel_reporting_lng_tank_detail: editInitialValues?.deck_officer?.vessel_reporting_lng_tank_detail,
                                            }
                                        })
                                        setRefreshKey(refreshKey + 1);
                                    }}
                                >
                                    Reset
                                </Button>
                            } */}
                            <Button
                                type={editReportBool ? "button" : "submit"}
                                color="primary"
                                className="btn_size_cstm"
                                disabled={isSubmitting || editIsSubmitting}
                                onClick={async () => {
                                    const validationErrors = await validateForm();
                                    Object.keys(values || {}).forEach((key: any) => {
                                        setFieldTouched(key, true);
                                    });
                                    if (editReportBool && Object.keys(validationErrors).length === 0) {
                                        await saveEditForm(editSubmit, toggleTab, activeTab, setPreviousDeckTabIndex);
                                        setRefreshKey((prev: number) => prev + 1);
                                    }
                                }}
                            >
                                {(isSubmitting || editIsSubmitting) && <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />}
                                Next <i className="bx bx-chevron-right ms-1" />
                            </Button>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <Button
                            type="button"  // Change from "submit" to "button"
                            color="primary"
                            className="btn_size_cstm"
                            onClick={() => {
                                toggleTab(activeTab - 1);
                                setErrorMessage(null);
                                setErrors({});
                            }}
                        >
                            <i className="bx bx-chevron-left me-1" /> Previous
                        </Button>
                    </Col>

                </Row>
            </CardFooter>
            <FormValuesDebug
                values={[values, errors, fieldAvailability, touched]}
            />
        </Form >
    )
}

export default ETADComponentStructure
